import { Icon } from '@graftcode/design-system'

import { ACADEMY_QUICKSTART_NAV_ITEMS } from '@common/config/academyQuickStartNavItems'

import { ACADEMY_MENU_ROUTES } from './academy-menu-routes.const'
import type { AcademyNavSection } from './academy-mobile-menu.interface'
import type { TutorialSection } from './types'

export { ACADEMY_CODE_SANDBOX_PATH, ACADEMY_MENU_ROUTES, IS_CODE_SANDBOX_ENABLED } from './academy-menu-routes.const'

export const DEFAULT_QUICKSTART_SECTIONS: TutorialSection[] = ACADEMY_QUICKSTART_NAV_ITEMS.map(
  ({ title, path, order }) => ({ title, path, order })
)

export const HIDDEN_MOBILE_SECTION_PATHS = new Set(['quick-start-guide'])

export const ACADEMY_NAV_SECTIONS: AcademyNavSection[] = [
  {
    items: [{ id: 'home', label: 'Home', path: ACADEMY_MENU_ROUTES.home, icon: Icon.HomeRegular }],
  },
  {
    label: 'Learn',
    items: [
      { id: 'quickStart', label: 'Quick start', path: ACADEMY_MENU_ROUTES.quickStart, icon: Icon.FastForwardRegular },
      {
        id: 'documentation',
        label: 'Documentation',
        path: ACADEMY_MENU_ROUTES.documentation,
        icon: Icon.DocumentRegular,
      },
      { id: 'glossary', label: 'Glossary', path: ACADEMY_MENU_ROUTES.glossary, icon: Icon.BookRegular },
      { id: 'videos', label: 'Videos', path: ACADEMY_MENU_ROUTES.videos, icon: Icon.VideoRegular },
    ],
  },
  {
    label: 'Practice',
    items: [{ id: 'codeSandbox', label: 'Code Sandbox', path: ACADEMY_MENU_ROUTES.codeSandbox, icon: Icon.DSTerminal }],
  },
]
